import { combineReducers } from 'redux'
import clients from './clients'

export default combineReducers({
  clients
})